<template>
  <div>
    <el-input
      :ref="refValue"
      @blur="onBlur"
      @change="onChange"
      v-model="cmpValue"
      v-bind:label="label"
      v-bind:placeholder="placeholder"
      v-bind:readonly="readonly"
      v-bind:disabled="disabled"
      v-bind:outlined="outlined"
      v-bind:dense="dense"
      v-bind:hide-details="hideDetails"
      v-bind:error="error"
      v-bind:rules="rules"
      v-bind:clearable="clearable"
      v-bind:backgroundColor="backgroundColor"
      v-bind:prefix="options.prefix"
      v-bind:suffix="options.suffix"
      v-on:keypress="keyPress"
    ></el-input>
  </div>
</template>

<script>
import EventBus from "@/service/EventBus";
export default {
  model: { prop: "value", event: "input" },
  props: {
    refProp: {
      type: String,
      default: "inputMoney"
    },
    refProp1: {
      type: String,
      default: "inputMoney1"
    },
    value: {
      // type: String,
      type: [String, Number],
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: undefined
    },
    readonly: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: [Boolean, String],
      default: false
    },
    rules: {
      type: [Array, String],
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: "white"
    },
    valueWhenIsEmpty: {
      type: String,
      default: undefined  // "0" or "" or null
    },
    options: {
      type: Object,
      default: function() {
        return {
          locale: 'pt-BR',
          prefix: 'R$',
          suffix: '',
          length: 100,
          precision: 0,
        };
      },
    },
  },
  data: () => ({}),
  /*
   v-model="cmpValue": Dessa forma, ao digitar, o valor Ã© atualizado automaticamente no componente pai.
   O valor digitado entra pelo newValue do Set e Ã© emitido para o componente pai.
   the-vue-mask nao funciona corretamente ao incluir valores existentes no componente pai.
  */
  computed: {
    cmpValue: {
      get: function() {
        return this.value !== null && this.value !== ""
          ? this.humanFormat(this.value.toString())
          : this.valueWhenIsEmpty;
      },
      set: function(newValue) {
        console.log('newValue', newValue);
        this.$emit("input", this.machineFormat(newValue))
      },
    },
    refValue: {
      get: function() {
        if (this.refProp === 'inputMoney') return this.refProp1
        return this.refProp
      }
    }
  },
  methods: {
    onBlur() {
      this.$emit("onblurInput");
    },
    onChange() {
      this.$emit("onchangeInput")
    },
    humanFormat: function(number) {
      if (isNaN(number)) {
        number = "";
      } else {
        // number = Number(number).toLocaleString(this.options.locale, {maximumFractionDigits: 2, minimumFractionDigits: 2, style: 'currency', currency: 'BRL'});
        number = Number(number).toLocaleString(this.options.locale, {
          maximumFractionDigits: this.options.precision,
          minimumFractionDigits: this.options.precision,
        });
      }
      return number;
    },
    machineFormat(number) {
      if (number) {
        number = this.cleanNumber(number);
        // Ajustar quantidade de zeros Ã  esquerda
        number = number.padStart(parseInt(this.options.precision) + 1, "0")
        // Incluir ponto na casa correta, conforme a precisÃ£o configurada
        number = number.substring(0, number.length - parseInt(this.options.precision)) + "." + number.substring(number.length - parseInt(this.options.precision), number.length)
        if (isNaN(number)) {
          number = this.valueWhenIsEmpty;
        }
      } else {
        number = this.valueWhenIsEmpty;
      }
      if (this.options.precision === 0) {
        number = this.cleanNumber(number);
      }
      return number;
    },
    keyPress($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
      if (this.targetLength()) {
        $event.preventDefault();
      }
    },
    // Retira todos os caracteres nÃ£o numÃ©ricos e zeros Ã  esquerda
    cleanNumber: function(value) {
      let result = "";
      if (value) {
        let flag = false;
        let arrayValue = value.toString().split("");
        for (const element of arrayValue) {
          if (this.isInteger(element)) {
            if (!flag) {
              // Retirar zeros Ã  esquerda
              if (element !== "0") {
                result = result + element;
                flag = true;
              }
            } else {
              result = result + element;
            }
          }
        }
      }
      return result;
    },
    isInteger(value) {
      let result = false;
      if (Number.isInteger(parseInt(value))) {
        result = true;
      }
      return result;
    },
    targetLength() {
      return Number(this.cleanNumber(this.value).length) >= Number(this.options.length)
    },
  },
  watch: {
    refProp: function(newValue) {
      console.log('newValue', newValue);
    },
  },
  created() {
    EventBus.$off(`focusInput_${this.refValue}`)
    EventBus.$on(`focusInput_${this.refValue}`, (data) => {
      setTimeout(() => {
        this.$refs[data.field].focus()
      }, 100)
    })
  },
}
</script>
